const offices = [
  {
    name: 'Chicago',
    value: 'Chicago',
    headquarters: true,
    street: '2651 Warrenville Rd, Suite 500',
    city: 'Downers Grove',
    state: 'IL',
    zip: '60515',
    phone: '847.699.2999',
  },
  {
    name: 'Atlanta',
    value: 'Atlanta',
    phone: '678.983.4833',
  },
  {
    name: 'Cincinnati',
    value: 'Cincinnati',
    street: '6285 Schumacher Park Dr.',
    city: 'West Chester',
    state: 'OH',
    zip: '45069',
    phone: '513.942.9202',
  },
  {
    name: 'Cleveland',
    value: 'Cleveland',
    street: '4199 Kinross Lakes Parkway, Suite 235',
    city: 'Richfield',
    state: 'OH',
    zip: '44286',
    phone: '330.650.5300',
  },
  {
    name: 'Columbus',
    value: 'Columbus',
    street: '655 Metro Place South, Suite 340',
    city: 'Dublin',
    state: 'OH',
    zip: '43017',
    phone: '614.799.2339',
  },
  {
    name: 'Dallas/Ft. Worth',
    value: 'Dallas/Ft. Worth',
    street: '603 Munger Ave, Suite 100-210',
    city: 'Dallas',
    state: 'TX',
    zip: '75202',
    phone: '817.313.6739',
  },
  {
    name: 'Des Moines',
    value: 'Des Moines',
    phone: '515.223.4800',
  },
  {
    name: 'Fort Scott',
    value: 'Fort Scott',
    street: '113 N Broadway St',
    city: 'Pittsburg',
    state: 'KS',
    zip: '66762',
    phone: '620.223.1989',
  },
  {
    name: 'Grand Rapids',
    value: 'Grand Rapids',
    street: '99 Monroe Avenue NW, Suite 200',
    city: 'Grand Rapids',
    state: 'MI',
    zip: '49503',
    phone: '616.581.4523',
  },
  {
    name: 'Hartford',
    value: 'Hartford',
    street: '1336 East Main Street',
    city: 'Meriden',
    state: 'CT',
    zip: '06450',
    phone: '203.494.4044',
  },
  {
    name: 'Kansas City',
    value: 'Kansas City',
    street: '5201 Johnson Drive, Suite 250',
    city: 'Mission',
    state: 'KS',
    zip: '66205',
    phone: '913.432.4333',
  },
  {
    name: 'Las Vegas',
    value: 'Las Vegas',
    street: '6543 S. Las Vegas Blvd., Suite 200',
    city: 'Las Vegas',
    state: 'NV',
    zip: '89119',
    phone: '725.900.1489',
  },
  {
    name: 'St. Louis',
    value: 'St. Louis',
    street: '11140 South Towne Square, Suite 101',
    city: 'St Louis',
    state: 'MO',
    zip: '63123',
    phone: '314.966.2300',
  },
];
export default offices;
